import { render, staticRenderFns } from "./dialog-head-icon.mpx?vue&type=template&id=7ff92e83&isComponent&outputPath=components%2Fdialog-head-icon312f105a%2Findex"
import script from "./dialog-head-icon.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-head-icon312f105a%2Findex"
export * from "./dialog-head-icon.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-head-icon312f105a%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports